import React from 'react';

import { Typography } from '@mui/material';

interface TourCancellationWarningProps {
  shouldDisallowTourCancellation: boolean;
}

export default function TourCancellationWarning({ shouldDisallowTourCancellation }: TourCancellationWarningProps) {
  if (!shouldDisallowTourCancellation) {
    return null;
  }

  return (
    <>
      <Typography color="red"> This tour is not cancellable as there's an active Optional Extra</Typography>
      <Typography color="red"> To additionally cancel this tour the Optional Extras must be cancelled first</Typography>
    </>
  );
}
